import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { apiClient } from 'config/api';
import useCustomerId from '../useCustomerId';

/**
 * Custom hook to manage area balance assignment.
 * @param mutate mutate areas and company balances.
 */
function useAssignBalanceToArea(mutate: () => void) {
  const [isLoading, setIsLoading] = useState(false);
  const [isAssignBalanceModalOpen, setIsAssignBalanceModalOpen] = useState(false);
  const [showAssignBalanceAlert, setShowAssignBalanceAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [values, setValues] = useState({ areaId: '', amount: '' });
  const params = useParams();
  const { customerId } = useCustomerId();
  /**
   * Function to assign balance to an area.
   */
  const submit = async () => {
    setIsLoading(true);
    try {
      const { data } = await apiClient.post('/v3/client/area/assignment', {
        ...values,
        amount: values.amount.replace(',', '.'),
        customerId: params.customerId ?? customerId,
      });
      setIsLoading(false);
      closeAlert();
      openSuccessAlert();
      mutate();
      return data;
    } catch (error) {
      setIsLoading(false);
      closeAlert();
    }
  };
  /**
   * Handle set the body values and open the confirmation modal
   * @param body
   */
  const handleSetValues = (body: { amount: string; areaId: string }) => {
    setValues(body);
    closeModal();
    openAlert();
  };
  /**
   * Close assign balance to area modal
   */
  const closeModal = () => {
    setIsAssignBalanceModalOpen(false);
  };
  /**
   * Open assign balance to area modal
   */
  const openModal = () => {
    setIsAssignBalanceModalOpen(true);
  };
  /**
   * Close assign balance alert modal
   */
  const closeAlert = () => {
    setShowAssignBalanceAlert(false);
  };
  /**
   * Open assign balance alert modal
   */
  const openAlert = () => {
    setShowAssignBalanceAlert(true);
  };
  /**
   * Close assign balance success alert modal
   */
  const closeSuccessAlert = () => {
    setShowSuccessAlert(false);
  };
  /**
   * Open assign balance success alert modal
   */
  const openSuccessAlert = () => {
    setShowSuccessAlert(true);
  };
  return {
    isLoading,
    submit,
    isAssignBalanceModalOpen,
    closeModal,
    openModal,
    closeAlert,
    openAlert,
    showAssignBalanceAlert,
    values,
    handleSetValues,
    closeSuccessAlert,
    showSuccessAlert,
  };
}

export default useAssignBalanceToArea;
